import React from 'react'
import styled from 'styled-components';
import {InnerLayout} from '../styles/Layouts';
import Title from '../Components/Title';
import Button1 from './Button1';
// ,"JAVASCRIPT","REACT","REDUX"

const language = ["html.png","css.png","js.png"]
const  front = ["react.png","redux.png","yard.png","material.png","framermotion.png","styledcompo.png"]
const back = ["nodejs.png","express.png","firebase.png","mongoose.png","mongodb.png"]
const soft = ["TEAM PLAYER","Good Communication","Creative"]
function Skills() {
    return (
        <SkillsStyled>
            
                <Title title={'My Skills'} span={'my skills'} />
                <InnerLayout>
                    <div className="skills">
                    <Button1 button={language} title = "LANGUAGES"/>
                    
                      <Button1 button={front} title = "FRONT-END"/>
                      <Button1 button={back} title = "BACK-END"/>
                    
                      {/* <Button1 button={soft} title = "SOFT-SKILLS"/> */}
                    </div>
                </InnerLayout>
        </SkillsStyled>
    )
}

const SkillsStyled = styled.section`
    .skills{
        display: grid;
        grid-template-columns: repeat(1, 1fr);
        grid-row-gap: 2rem;
        grid-column-gap: 1rem;
        width:70%;
        margin:auto;
        @media screen and (max-width: 700px){
            grid-template-columns: repeat(1, 1fr);
            width:80%;
            margin:auto;
        }
    }
`;

export default Skills;
